import { checkAuthFx } from '@/modules/auth/store/auth.store';
import { DiContainer } from '@/modules/di/di-container';
import { Modal, notification } from 'antd';
import { BuyerAccount } from '../services/buyer-account.service';
import { IBuyer } from '../ts';
import { isString } from 'lodash-es';

const buyerAccount = DiContainer.get(BuyerAccount);

export const updateBuyerData = (formState: IBuyer) => {
  const errors = [];
  if (
    !formState.companyName ||
    !formState.address
    // !formState.phone ||
    // !formState.email
  ) {
    errors.push({
      message: 'Не заполнены обязательные поля',
      description: 'Поля, отмеченные знаком "*" являются обязательными к заполнению',
    });
  }

  if (formState.companyName.length < 5 || formState.companyName.length > 128) {
    errors.push({
      message: 'Некорректное название компании',
      description: 'Название компании может содержать от 5 до 128 символов',
    });
  }

  // if (!formState.email.includes('@') || !formState.email.includes('.')) {
  //   errors.push({
  //     message: 'Некорректный email',
  //     description: 'Email указан в неправильном формате',
  //   });
  // }

  if (
    formState.address === '' ||
    formState.address.length > 128 ||
    formState.address.length < 5
  ) {
    errors.push({
      message: 'Некорректный адрес',
      description: 'Поле адрес может содержать от 5 до 128 символов',
    });
  }

  // if (formState.phone.replace(/[^0-9+]/g, "").length !== 12)
  //   errors.push({
  //     message: 'Некорректный номер телефона',
  //     description: 'Номер телефона указан в неправильном формате',
  //   });

  if (formState.inn && formState.inn.length > 0 && formState.inn.length !== 10) {
    errors.push({
      message: 'Некорректный  ИНН',
      description: 'ИНН должен содержать 10 цифр',
    });
  }

  if (formState.ogrn && formState.ogrn.length > 0 && formState.ogrn.length !== 13) {
    errors.push({
      message: 'Некорректный  ОГРН',
      description: 'ОГРН должен содержать 13 цифр',
    });
  }

  if (errors.length > 0) {
    return errors.map((errItem) => notification.warning(errItem));
  }

  Modal.confirm({
    title: 'Подтвердите действие',
    content: 'Вы действительно хотите обновить данные о Вашей компании?',
    okText: 'да',
    cancelText: 'нет',
    onOk: async () => {
      try {
      let res: any = await buyerAccount.editBuyerAccount({
        name: formState.companyName,
        address: formState.address,
        inn: formState.inn,
        ogrn: formState.ogrn,
        // phone: formState.phone,
        // email: formState.email,
      });

      if (res.headers) {
        res = await res.json();
      }
      
      if ('error' in res) {
        try {
          if (res.error) {
            return notification.error({
              message: 'Ошибка',
              description: isString(res.error)
                ? res.error
                : 'Непредвиденная ошибка. Попробуйте позже.',
            });
          }
        } catch (err) {
          return notification.error({
            message: 'Непредвиденная ошибка. Попробуйте позже.',
          });
        }
      }
      notification.success({ message: 'Информация о компании успешно обновлена!' });
      await checkAuthFx();
    } catch (err: any) {
      const parsed = err.headers && await err.json();
      return notification.error({
        message: 'Ошибка',
        description: isString(parsed?.error)
          ? parsed?.error
          : 'Непредвиденная ошибка. Попробуйте позже.',
      });
    }
    },
  });
};
